import React, { useEffect, useState } from "react";
import { provider, useExpand } from "shared";
import MobileRoutingPages from "pages/mobile";
import SiteRoutingPages from "pages/site";
import PullToRefreshComponent from "feature/pullToRefresh";
/*
import {
  TonConnectUIProvider,
  TonConnectButton,
  useTonAddress,          // готовый хук
} from '@tonconnect/ui-react';

function Header() {
  return (
    <header>
      <TonConnectButton />   
    </header>
  );
}

function WalletInfo() {
  const [usdtBalance, setUsdtBalance] = useState<number>(0);
  const address = useTonAddress();        // user-friendly by default
  const USDT_MASTER =
  'EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs';

  useEffect(() => {
    if (address) {
      getUsdtBalance(address).then(setUsdtBalance);
    }
  }, [address]);

async function getUsdtBalance(address: string) {
  const r = await fetch(
    `https://tonapi.io/v2/accounts/${address}/jettons/${USDT_MASTER}`
  );
  if (!r.ok) throw new Error('TonAPI error');
  const { balance } = await r.json();     // баланс в наноджеттонах
  return Number(balance) / 1e6;          // переводим в USDT (6 знаков)
}
  if (!address) return null;
  return (<div><p>Ваш TON/USDT адрес: {address}</p> 
  <p>Баланс: {usdtBalance} USDT</p></div>);
}

   */   
const App = () => {
  const [, expand] = useExpand();
  useEffect(() => {
    expand();
  }, []);
  return (
    <PullToRefreshComponent>
      <div>
        <provider.WebAppProvider options={{ smoothButtonsTransition: true }}>
          <provider.ThemeProvider>
            <provider.TokenProvider
              otherMethodChildren={<MobileRoutingPages />}
              qrCodeChildren={<SiteRoutingPages />}
            >
              {/*
              <TonConnectUIProvider
      manifestUrl="https://w0m8m42p-3000.euw.devtunnels.ms/tonconnect-manifest.json"
      actionsConfiguration={{ 
        twaReturnUrl: 'https://t.me/hedger_test_bot?startapp'
      }}>
                <Header />
                <WalletInfo />
              </TonConnectUIProvider>*/}
            </provider.TokenProvider>
          </provider.ThemeProvider>
        </provider.WebAppProvider>
      </div>
    </PullToRefreshComponent>
  );
};

export default App;
